module.exports = __webpack_public_path__ + "static/img/sj_js_2.89428fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sj/sj_js_2.png
// module id = JLN/
// module chunks = 1